import { createAction } from "@logicsoftware/redux-toolkit";
import { call, takeEvery } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { runPresetsReloading } from "~/Redux/preset/state/sagas/watchReloadPresets";
import { callApi } from "~/Redux/Sagas/effects/callApi";
import { loadSpaces } from "~/Redux/Spaces/state/sagas/loadSpaces";
import { Space } from "../../types";

type NewSpace = Pick<Space, "Name" | "Icon" | "Color"> & {
    callback: (args: { SpaceId: number }) => void;
};
export const createSpace = createAction<NewSpace>("SPACES/CREATE_SPACE");

export function* watchCreateSpace() {
    yield takeEvery(createSpace, function* ({ payload: { callback, ...space } }) {
        const { SpaceId } = yield callApi(({ ajaxOptions }) =>
            OAuthClient.postJson(appUrls.spaces.create, space, ajaxOptions)
        );

        yield loadSpaces();
        yield runPresetsReloading();

        yield call(() => callback({ SpaceId }));
    });
}
